// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","requestMessageTagWrapper":"styles_requestMessageTagWrapper__lxB4R","requestMessageTagRow":"styles_requestMessageTagRow__2mEye"};